module.exports = __webpack_public_path__ + "static/img/IMG_20240803_214142.653d41e5.jpg";